/**
 * API Helper Utilities
 *
 * Common utilities for building API requests.
 */

// ============================================================================
// Query Parameter Builders
// ============================================================================

/**
 * Build pagination query parameters.
 */
export function buildPaginationParams(pageSize?: number, pageToken?: string): Record<string, number | string | undefined> {
   
  return {
    'pagination.pageSize': pageSize,
    'pagination.pageToken': pageToken,
  };
   
}

/**
 * Build date range query parameters using 'dateRange' prefix.
 */
export function buildDateRangeParams(startDate?: string, endDate?: string): Record<string, string | undefined> {
   
  return {
    'dateRange.startDate': startDate,
    'dateRange.endDate': endDate,
  };
   
}

/**
 * Build period date range query parameters using 'period' prefix.
 * Used for reporting endpoints.
 */
export function buildPeriodParams(startDate?: string, endDate?: string): Record<string, string | undefined> {
   
  return {
    'period.startDate': startDate,
    'period.endDate': endDate,
  };
   
}

// ============================================================================
// Error Helpers
// ============================================================================

export interface ApiError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

/**
 * Create a default unknown error object.
 */
export function createUnknownError(message = 'Unknown error'): ApiError {
  return {
    code: 'UNKNOWN',
    message,
  };
}

/**
 * Ensure an error object exists, providing a default if not.
 */
export function ensureError(error: ApiError | undefined): ApiError {
  return error ?? createUnknownError();
}

// ============================================================================
// Query Parameter Constants
// ============================================================================

 
export const QUERY_PARAMS = {
  PAGINATION: {
    PAGE_SIZE: 'pagination.pageSize',
    PAGE_TOKEN: 'pagination.pageToken',
  },
  DATE_RANGE: {
    START_DATE: 'dateRange.startDate',
    END_DATE: 'dateRange.endDate',
  },
  PERIOD: {
    START_DATE: 'period.startDate',
    END_DATE: 'period.endDate',
  },
} as const;
 
